module.exports = __webpack_public_path__ + "media/images/admin/icons/gitlab-6c274a89c888c9e2ecc3645c0cc93f86.svg";